import { showSuccessToast, showErrorToast } from '@shared/toasts/toasts.state';
import { setSubmitChangePaymentMethodFlags } from '@domain/billing/payment-method/payment-method.state';
import { createMiddleware } from '../../../shared/redux';
import {
    postBillingDetailsRequest,
    editBillingDetailsRequest,
    setBillingDetailsErros,
    SUBMIT_BILLING_DETAILS,
    POST_BILLING_DETAILS_REQUEST_SUCCEEDED,
    POST_BILLING_DETAILS_REQUEST_FAILED,
    GET_BILLING_DETAILS_REQUEST_SUCCEEDED,
    GET_BILLING_DETAILS_REQUEST_FAILED,
    EDIT_BILLING_DETAILS_REQUEST_SUCCEEDED,
} from './billing-details.state';
import { validateBillingDetails } from './billing-details.validation';
import { setSubmitOrderFlags } from '../order/order.state';
import { BILLING_DETAILS_TEXTS } from './billing-details.constants';
import { changeOrderModalStep, changePaymentMethodModalStep } from '../interface/interface.state';

export const billingDetailsMiddlewares = createMiddleware({
    [SUBMIT_BILLING_DETAILS]: (_, action) => {
        const { payload: { data } } = action;
        const requestAction = data.id ? editBillingDetailsRequest : postBillingDetailsRequest;

        return validateBillingDetails(data)
            .then(() => [
                setBillingDetailsErros({}),
                requestAction({ data }),
            ])
            .catch(erros => setBillingDetailsErros(erros));
    },
    [POST_BILLING_DETAILS_REQUEST_SUCCEEDED]: () => [
        setSubmitOrderFlags({ hasBillingDetails: true }),
        setSubmitChangePaymentMethodFlags({ hasBillingDetails: true }),
        changeOrderModalStep({ simulation: true }),
        changePaymentMethodModalStep({ paymentMethod: true }),
        showSuccessToast({
            message: BILLING_DETAILS_TEXTS.CREATED_SUCCESS,
        }),
    ],
    [POST_BILLING_DETAILS_REQUEST_FAILED]: () => showErrorToast({
        message: 'There was an error creating your billing details. Try again in a few seconds.',
    }),
    [GET_BILLING_DETAILS_REQUEST_SUCCEEDED]: () => [
        setSubmitOrderFlags({ hasBillingDetails: true }),
        setSubmitChangePaymentMethodFlags({ hasBillingDetails: true }),
    ],
    [GET_BILLING_DETAILS_REQUEST_FAILED]: (_, action) => {
        const statusCode = action.payload.response.status;
        const notFound = 404;

        if (statusCode === notFound) return [];

        return showErrorToast({
            message: 'There was an error getting your payment information. Try again in a few seconds.',
        });
    },
    [EDIT_BILLING_DETAILS_REQUEST_SUCCEEDED]: () => [
        showSuccessToast({ message: BILLING_DETAILS_TEXTS.EDITED_SUCCESS }),
        changeOrderModalStep({ simulation: true }),
    ],
});
